module.exports = __webpack_public_path__ + "img/c1.fc95736b.png";